export default __webpack_public_path__ + "static/media/Fala podluzna.8a39c771.png";